module.exports = __webpack_public_path__ + "static/media/spiral2D.27319343.mp4";